import * as types from './types';

export default (state = {
  tagReminders: { content: [] },
  isFetchingTagReminders: false,
  tagRemindersError: null,
  tagRemindersRequestId: null,
  // TAG
  tagTagReminders: [],
  tagRemindersByTag: {},
  isFetchingTagTagReminders: false,
  tagTagRemindersError: null,
  tagTagRemindersRequestId: null,
  tagTagRemindersTagId: null,
  // MAX DUE DATE
  tagRemindersForDueDate: [],
  isFetchingTagRemindersForDueDate: false,
  tagRemindersForDueDateError: null,
  tagRemindersForDueDateRequestId: null,
}, action = {}) => {
  switch (action.type) {
    case types.GET_TAG_REMINDERS_REQUESTED:
      return {
        ...state,
        tagReminders: { content: [] },
        isFetchingTagReminders: true,
        tagRemindersError: null,
        tagRemindersRequestId: action.requestId,
      };
    case types.GET_TAG_REMINDERS_SUCCESS:
      if (action.requestId !== state.tagRemindersRequestId) { return state; }
      return {
        ...state,
        isFetchingTagReminders: false,
        tagReminders: action.tagReminders,
      };
    case types.GET_TAG_REMINDERS_ERROR:
      if (action.requestId !== state.tagRemindersRequestId) { return state; }
      return {
        ...state,
        tagRemindersError: action.error,
        isFetchingTagReminders: false,
      };
    case types.GET_TAG_REMINDER_SUCCESS:
      return {
        ...state,
        tagReminders: {
          ...state.tagReminders,
          content: state.tagReminders.content.map((tr) => ((action.tagReminder && tr.id === action.tagReminder.id)
            ? action.tagReminder
            : tr)),
        },
        tagRemindersByTag: Object.fromEntries(Object.entries(state.tagRemindersByTag).map(([tagId, cached]) => [tagId, {
          ...cached,
          content: cached.content.map((reminder) => ((action.tagReminder && reminder.id === action.tagReminder.id)
            ? action.tagReminder
            : reminder)),
        }])),
        tagTagReminders: state.tagTagReminders.map((tr) => ((action.tagReminder && tr.id === action.tagReminder.id)
          ? action.tagReminder
          : tr)),
      };
    case types.GET_TAG_TAG_REMINDERS_REQUESTED:
      return {
        ...state,
        tagTagReminders: [],
        tagRemindersByTag: {
          ...state.tagRemindersByTag,
          [action.tagId]: {
            content: [],
            isFetching: true,
            error: null,
            requestId: action.requestId,
          },
        },
        tagTagRemindersTagId: action.tagId,
        isFetchingTagTagReminders: true,
        tagTagRemindersError: null,
        tagTagRemindersRequestId: action.requestId,
      };
    case types.GET_TAG_TAG_REMINDERS_SUCCESS:
    case types.GET_TAG_TAG_REMINDERS_ERROR: {
      const cached = state.tagRemindersByTag[action.tagId];
      if (!cached || action.requestId !== cached.requestId) { return state; }
      const content = action.tagReminders || [];
      const error = action.error || null;
      const nextState = {
        ...state,
        tagRemindersByTag: {
          ...state.tagRemindersByTag,
          [action.tagId]: {
            ...cached,
            content,
            error,
            isFetching: false,
          },
        },
      };
      if (action.requestId !== state.tagTagRemindersRequestId) { return nextState; }
      return {
        ...nextState,
        tagTagRemindersError: error,
        isFetchingTagTagReminders: false,
        tagTagReminders: content,
      };
    }
    case types.GET_TAG_REMINDERS_MAX_DUE_DATE_REQUESTED:
      return {
        ...state,
        tagRemindersForDueDate: [],
        isFetchingTagRemindersForDueDate: true,
        tagRemindersForDueDateError: null,
        tagRemindersForDueDateRequestId: action.requestId,
      };
    case types.GET_TAG_REMINDERS_MAX_DUE_DATE_SUCCESS:
      if (action.requestId !== state.tagRemindersForDueDateRequestId) { return state; }
      return {
        ...state,
        isFetchingTagRemindersForDueDate: false,
        tagRemindersForDueDate: action.tagRemindersForDueDate,
      };
    case types.GET_TAG_REMINDERS_MAX_DUE_DATE_ERROR:
      if (action.requestId !== state.tagRemindersForDueDateRequestId) { return state; }
      return {
        ...state,
        tagRemindersForDueDateError: action.error,
        isFetchingTagRemindersForDueDate: false,
      };
    default:
      return state;
  }
};

